import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { FacebookShareButton, TwitterShareButton, FacebookIcon, XIcon, LinkedinIcon, LinkedinShareButton, WhatsappIcon, WhatsappShareButton, RedditShareButton, RedditIcon, TumblrIcon, TumblrShareButton, PinterestShareButton, PinterestIcon, EmailIcon } from 'react-share';
import './css/ShareComponent1.css';
import { context } from '../../../../globalState/GlobalState';
import { isValidObject, isValidString } from '../../../../catalog/Validity';
import { sendCustomAnalytics } from '../../../../catalog/Analytics';

const ShareComponent1 = (props) => {
    const { title, image, url, shareTitle, center, marginTop, marginBottom, marginLeft, mobileMarginTop, mobileMarginBottom, mobileMarginLeft } = props;
    const { globalState } = useContext(context);

    const getTwitterHashTags = () => {
        if (isValidObject(globalState) && isValidObject(globalState.socials) && isValidString(globalState.socials.sharingHashTags)) {
            const tempHashTag = globalState.socials.sharingHashTags.replace(/\s/g, '');
            const tempHashTag1 = tempHashTag.replace(/#\b/g, '');
            const tempHashTag2 = tempHashTag1.split(',');
            return tempHashTag2;
        }
        return [];
    };

    const getFacebookHashTags = () => {
        if (isValidObject(globalState) && isValidObject(globalState.socials) && isValidString(globalState.socials.sharingHashTags)) {
            const tempHashTag = globalState.socials.sharingHashTags.replace(/\s/g, '');
            const tempHashTag1 = tempHashTag.replace(/#\b/g, '');
            const tempHashTag2 = tempHashTag1.split(',');
            const tempHashTag3 = `#${tempHashTag2.join(' #')}`;
            return tempHashTag3;
        }
        return '';
    };

    return (
        <div className="share-component-1-container">
            <div className={`share-component-1 share-component-1-desktop ${center ? 'share-component-1-center' : 'share-component-1-left'} m-t-${marginTop}px m-b-${marginBottom}px m-l-${marginLeft}px`}>
                <FacebookShareButton
                    className="button m-r-10px"
                    url={url}
                    quote={shareTitle}
                    // hashtag={getFacebookHashTags()}
                    description={shareTitle}
                    onClick={() => { sendCustomAnalytics('share', { socialMedium: 'facebook', socialTitle: title.toLowerCase() }); }}
                >
                    <FacebookIcon size={50} round />
                </FacebookShareButton>
                <TwitterShareButton
                    className="button m-r-10px"
                    title={shareTitle}
                    url={url}
                    hashtags={getTwitterHashTags()}
                    onClick={() => { sendCustomAnalytics('share', { socialMedium: 'twitter', socialTitle: title.toLowerCase() }); }}
                >
                    <XIcon size={50} round />
                </TwitterShareButton>
                <a
                    className="button m-r-10px"
                    href={`mailto:?subject=${shareTitle}&body=${shareTitle}: ${url}`}
                    onClick={() => { sendCustomAnalytics('share', { socialMedium: 'email', socialTitle: title.toLowerCase() }); }}
                >
                    <EmailIcon size={50} round />
                </a>
                <WhatsappShareButton
                    className="button m-r-10px"
                    title={shareTitle}
                    url={url}
                    onClick={() => { sendCustomAnalytics('share', { socialMedium: 'whatsapp', socialTitle: title.toLowerCase() }); }}
                >
                    <WhatsappIcon size={50} round />
                </WhatsappShareButton>
                <LinkedinShareButton
                    className="button m-r-10px"
                    title={shareTitle}
                    summary={shareTitle}
                    source={url}
                    url={url}
                    onClick={() => { sendCustomAnalytics('share', { socialMedium: 'linkedin', socialTitle: title.toLowerCase() }); }}
                >
                    <LinkedinIcon size={50} round />
                </LinkedinShareButton>
                <RedditShareButton
                    className="button m-r-10px"
                    title={shareTitle}
                    summary={shareTitle}
                    source={url}
                    url={url}
                    onClick={() => { sendCustomAnalytics('share', { socialMedium: 'reddit', socialTitle: title.toLowerCase() }); }}
                >
                    <RedditIcon size={50} round />
                </RedditShareButton>
                <TumblrShareButton
                    className="button m-r-10px"
                    title={shareTitle}
                    summary={shareTitle}
                    source={url}
                    url={url}
                    onClick={() => { sendCustomAnalytics('share', { socialMedium: 'tumblr', socialTitle: title.toLowerCase() }); }}
                >
                    <TumblrIcon size={50} round />
                </TumblrShareButton>
                {isValidString(image) ? (
                    <PinterestShareButton
                        className="button m-r-10px"
                        title={shareTitle}
                        summary={shareTitle}
                        source={url}
                        url={url}
                        media={image}
                        onClick={() => { sendCustomAnalytics('share', { socialMedium: 'pinterest', socialTitle: title.toLowerCase() }); }}
                    >
                        <PinterestIcon size={50} round />
                    </PinterestShareButton>
                ) : null}
            </div>
            <div className={`share-component-1 share-component-1-mobile ${center ? 'share-component-1-center' : 'share-component-1-left'} m-t-${mobileMarginTop}px m-b-${mobileMarginBottom}px m-l-${mobileMarginLeft}px`}>
                <FacebookShareButton
                    className="button m-r-10px"
                    url={url}
                    quote={shareTitle}
                    hashtag={getFacebookHashTags()}
                    description={shareTitle}
                    onClick={() => { sendCustomAnalytics('share', { socialMedium: 'facebook', socialTitle: title.toLowerCase() }); }}
                >
                    <FacebookIcon size={35} round />
                </FacebookShareButton>
                <TwitterShareButton
                    className="button m-r-10px"
                    title={shareTitle}
                    url={url}
                    hashtags={getTwitterHashTags()}
                    onClick={() => { sendCustomAnalytics('share', { socialMedium: 'twitter', socialTitle: title.toLowerCase() }); }}
                >
                    <XIcon size={35} round />
                </TwitterShareButton>
                <a
                    className="button m-r-10px"
                    href={`mailto:?subject=${shareTitle}&body=${shareTitle}: ${url}`}
                    onClick={() => { sendCustomAnalytics('share', { socialMedium: 'email', socialTitle: title.toLowerCase() }); }}
                >
                    <EmailIcon size={35} round />
                </a>
                <WhatsappShareButton
                    className="button m-r-10px"
                    title={shareTitle}
                    url={url}
                    onClick={() => { sendCustomAnalytics('share', { socialMedium: 'whatsapp', socialTitle: title.toLowerCase() }); }}
                >
                    <WhatsappIcon size={35} round />
                </WhatsappShareButton>
                <LinkedinShareButton
                    className="button m-r-10px"
                    title={shareTitle}
                    summary={shareTitle}
                    source={url}
                    url={url}
                    onClick={() => { sendCustomAnalytics('share', { socialMedium: 'linkedin', socialTitle: title.toLowerCase() }); }}
                >
                    <LinkedinIcon size={35} round />
                </LinkedinShareButton>
                <RedditShareButton
                    className="button m-r-10px"
                    title={shareTitle}
                    summary={shareTitle}
                    source={url}
                    url={url}
                    onClick={() => { sendCustomAnalytics('share', { socialMedium: 'reddit', socialTitle: title.toLowerCase() }); }}
                >
                    <RedditIcon size={35} round />
                </RedditShareButton>
                {/* <TumblrShareButton
                    className="button m-r-10px"
                    title={shareTitle}
                    summary={shareTitle}
                    source={url}
                    url={url}
                    onClick={() => { sendCustomAnalytics('share', { socialMedium: 'tumblr', socialTitle: title.toLowerCase() }); }}
                >
                    <TumblrIcon size={35} round />
                </TumblrShareButton> */}
            </div>
        </div>
    );
};

ShareComponent1.propTypes = {
    title: PropTypes.string.isRequired,
    image: PropTypes.string,
    url: PropTypes.string.isRequired,
    shareTitle: PropTypes.string.isRequired,
    center: PropTypes.bool,
    marginTop: PropTypes.number,
    marginBottom: PropTypes.number,
    marginLeft: PropTypes.number,
    mobileMarginTop: PropTypes.number,
    mobileMarginBottom: PropTypes.number,
    mobileMarginLeft: PropTypes.number,
};

ShareComponent1.defaultProps = {
    image: '',
    center: false,
    marginTop: 10,
    marginBottom: 10,
    marginLeft: 50,
    mobileMarginTop: 10,
    mobileMarginBottom: 10,
    mobileMarginLeft: 10,
};

export default memo(ShareComponent1);
